export const client = '/client/v1/apply';
export const sso = '/sso';
export const ops = sso.concat('/ops');
export const img = 'http://192.168.1.102:3000/images'

export default {
  save: client.concat('/save'),
  login: sso.concat('/login'),
  getOpsList: ops.concat('/getOps'),
}
